if (!customElements.get('bend-label-choices')) {
  customElements.define('bend-label-choices', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.form = this.closest('form');
      this.input = this.querySelector('textarea');
      this.help = this.querySelector('[data-label-help]');
      this.errorMessage = this.querySelector('[data-label-error]');
      this.variants = JSON.parse(this.querySelector('[data-label-variants]').textContent);
      this.onVariantChange = () => {
        this.updateInstructions();
        this.clearError();
      };
      this.onInput = () => this.clearError();
      this.onSubmit = event => {
        const message = this.validationMessage();
        if (!message) {
          this.clearError();
          return;
        }
        event.preventDefault();
        event.stopImmediatePropagation();
        this.input.setAttribute('aria-invalid', 'true');
        this.input.setCustomValidity(message);
        this.errorMessage.textContent = message;
        this.errorMessage.hidden = false;
        this.input.focus();
      };
      this.form.addEventListener('submit', this.onSubmit, true);
      this.form.addEventListener('change', this.onVariantChange);
      this.input.addEventListener('input', this.onInput);
      this.updateInstructions();
    }

    disconnectedCallback() {
      this.form?.removeEventListener('submit', this.onSubmit, true);
      this.form?.removeEventListener('change', this.onVariantChange);
      this.input?.removeEventListener('input', this.onInput);
      this.initialized = false;
    }

    selectedCount() {
      const variantId = this.form.querySelector('[name="id"]').value;
      return this.variants[variantId] || 1;
    }

    updateInstructions() {
      this.help.textContent = this.selectedCount() === 10 ? this.dataset.helpPack : this.dataset.helpSingle;
    }

    clearError() {
      this.input.setCustomValidity('');
      this.input.removeAttribute('aria-invalid');
      this.errorMessage.textContent = '';
      this.errorMessage.hidden = true;
    }

    validationMessage() {
      const raw = this.input.value.trim();
      if (!raw) return this.dataset.errorRequired;
      if (this.dataset.freeText === 'true') return '';
      const names = raw.split(/\r?\n|,/).map(name => name.trim());
      if (names.some(name => !name)) return this.dataset.errorFormat;
      const count = this.selectedCount();
      if (names.length !== count) return count === 10 ? this.dataset.errorPack : this.dataset.errorSingle;
      const maximum = Number(this.dataset.maximumLength);
      if (maximum > 0 && names.some(name => Array.from(name).length > maximum)) return this.dataset.errorLength;
      return '';
    }
  });
}

